<template>
  <v-btn
    v-bind="$attrs"
    :class="{ 'v-btn--active': isActive }"
  >
    {{ text }}
  </v-btn>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  }
});
</script>

<script>
export default {
  name: 'MenuButton',
  inheritAttrs: false
}
</script>
